import { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import * as AppConstants from "../constants/AppConstants";
import useRouteParams from "../hooks/useRouteParams";
import {
  INDUSTRIES_LIST,
  TOPICS_LIST,
  TEMPLATE_SOLVERS_LIST,
} from "../constants/TemplatesConstants";
import { useFilterState } from "./useFilterState";

export const useListSearchFilters = (initialViewMode, totalItems) => {
  const history = useHistory();
  const { access } = useParams();
  const { searchParams } = useRouteParams();
  const location = useLocation(); // useLocation directly to get the current search string

  const initialPage = searchParams["page"] || 1;
  const initialQ = searchParams["q"] || "";
  const initialTime = searchParams["time"] || "all";
  const initialSolvers = searchParams["solvers"] || "";
  const initialTopics = searchParams["topics"] || "";
  const initialIndustries = searchParams["industries"] || "";

  const initialSearchQuery = [
    initialQ ? `q=${initialQ}` : "",
    `time=${initialTime}`,
  ]
    .filter(Boolean)
    .join("&");
  const initialFilterQuery = [
    initialSolvers ? `solvers=${initialSolvers}` : "",
    initialTopics ? `topics=${initialTopics}` : "",
    initialIndustries ? `industries=${initialIndustries}` : "",
  ]
    .filter(Boolean)
    .join("&");
  const [viewMode, setViewMode] = useState(initialViewMode);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [numPages, setNumPages] = useState(
    Math.ceil(totalItems / AppConstants.APP_DEFAULT_PAGE_SIZE)
  );
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);
  const [filterQuery, setFilterQuery] = useState(initialFilterQuery);

  // Effect to listen for changes in the URL and update state accordingly
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    setCurrentPage(parseInt(urlParams.get("page")) || 1);
    let initialQ = urlParams.get("q") || "";
    let initialTime = urlParams.get("time") || "all";
    setSearchQuery(() => {
      const search = [
        initialQ ? `q=${initialQ}` : "",
        initialTime ? `time=${initialTime}` : "",
      ]
        .filter(Boolean)
        .join("&");
      return search;
    });
    setFilterQuery(() => {
      const filters = [
        urlParams.get("solvers") ? `solvers=${urlParams.get("solvers")}` : "",
        urlParams.get("topics") ? `topics=${urlParams.get("topics")}` : "",
        urlParams.get("industries")
          ? `industries=${urlParams.get("industries")}`
          : "",
      ]
        .filter(Boolean)
        .join("&");
      return filters;
    });
  }, [location.search]); // This ensures the effect is triggered every time the URL search part changes

  const updateURLQuery = () => {
    let queryString = `?page=${currentPage}`;
    if (filterQuery) queryString += `&${filterQuery}`;
    if (searchQuery) queryString += `&${searchQuery}`;
    if (queryString !== history.location.search)
      history.push({ search: queryString });
  };

  // Effect to update URL query parameters
  useEffect(() => {
    updateURLQuery();
  }, [currentPage, filterQuery, searchQuery]);

  return {
    viewMode,
    setViewMode,
    setFilterQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    numPages,
  };
};
